import moment from 'moment';

/** The dateTime format specified by the DST Rest API */
export const DSTdateTimeFormat = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
/** A user-friendly dateTime format */
export const UIdateTimeFormat = 'YYYY-MM-DD HH:mm';
/** The date format specified by the DST Rest API */
export const photoTimeFormat = 'YYYY:MM:DD HH:mm:ss';
/** The date format specified by the DST Rest API */
export const dateFormat = 'YYYY-MM-DD';
/** Returns a boolean stating whether the given date is at midnight */
export function isMidnight(date: Date): boolean {
  return moment(date).format('HH-mm') === '00-00';
}

export const strToDate = (str: string): Date | null => {
  if (!str) {
    return null;
  }
  return moment(str, dateFormat).toDate();
};

export const photoDatestrToDate = (str: string): Date | null => {
  if (!str) {
    return null;
  }
  return moment(str, photoTimeFormat).toDate();
};

export const DSTstrToDateTime = (str: string): Date | null => {
  if (!str) {
    return null;
  }
  return moment(str, DSTdateTimeFormat).toDate();
};

export const UIstrToDateTime = (str: string): Date | null => {
  if (!str) {
    return null;
  }
  return moment(str, DSTdateTimeFormat).toDate();
};

export const dateToStr = (date: Date): string => moment(date).format(dateFormat);
export const dateTimeToDSTStr = (date: Date): string => moment(date).format(DSTdateTimeFormat);
export const dateTimeToUIStr = (date: Date): string => moment(date).format(UIdateTimeFormat);

export const nowDateStr = (): string => {
  const nowDate = new Date();
  return dateToStr(nowDate);
};
